module.exports = __webpack_public_path__ + "img/Figure-2-web-min.eebcc8b9.png";